// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import NotificationType from '@deere/cps-it.warranty-model-factory/lib/notification';

const Notification = props =>
    <li
        className='notification'
    >

        {props.notification.title !== '' &&
            <h4>
                {props.notification.title}
            </h4>
        }

        {props.notification.shortText !== '' &&
            <p>
                {props.notification.shortText}
            </p>
        }

        {props.notification.url !== '' &&
            <a
                href={props.notification.url}
                rel='noopener noreferrer'
                target='_blank'
            >
                <FormattedMessage id='CLICK_FOR_DETAILS'/>
            </a>
        }

    </li>;

Notification.displayName = 'Notification';
Notification.propTypes = {
    notification: PropTypes.instanceOf(NotificationType).isRequired
};

export default Notification;



// WEBPACK FOOTER //
// ./src/home-page/components/notification.js